<template>
  <div
    :class="[
      $style.badge,
      { [$style[`badge--${color}`]]: color },
      { [$style[`badge--${size}`]]: size }
    ]">
    <span
      v-if="text"
      :class="$style['badge__badge']">
      {{ text }}
    </span>

    <SvgIcon v-if="icon" :class="[$style['badge__badge'], $style['badge__badge--icon']]" :name="icon" />
    <slot />
  </div>
</template>
<script setup>
defineProps({
  color: {
    type: String,
    default: null
  },
  size: {
    type: String,
    default: null
  },
  text: {
    type: [Number, String, Boolean],
    default: null
  },
  icon: {
    type: String,
    default: null
  }
})
</script>
<style lang="scss" module>
.badge {
  display: inline-flex;
  position: relative;
  line-height: 1; // Keep it here

  &__badge {
    align-items: center;
    justify-content: center;
    background-color: $black;
    box-shadow: 0 0 0 2px $white;
    color: $white;
    border-radius: 100%;
    display: inline-flex;
    font-size: $font-size-xxxs;
    line-height: 10px;
    font-weight: $font-weight-bold;
    width: $spacing * 2;
    height: $spacing * 2;
    position: absolute;
    right: -$spacing;
    top: -$spacing * 0.5;
    will-change: opacity, transform;
    z-index: 1;
    transition: .3s;

    :global(.transparent-toolbar):not(:hover) & {
      box-shadow: 0 0 0 0 ;
    }
  }

  &--gold {
    .badge__badge {
      background-color: $gold;
      color: rgba($black, 0.8);
    }
  }

  &--success {
    .badge__badge {
      background-color: $success;
    }
  }

  &--fail {
    .badge__badge {
      background-color: $red;
    }
  }

  &--small {
    .badge__badge {
      box-shadow: 0 0 0 1px $white;
      width: $spacing * 1.75;
      height: $spacing * 1.75;
      right: -$spacing * 0.6;
      top: -$spacing * 0.5;

      @media (hover: none) and (max-width: #{$breakpoint-tablet - 1}) {
        :global(.transparent-toolbar) & {
          box-shadow: 0 0 0 0 ;
        }
      }

      @media (pointer: coarse) and (max-width: #{$breakpoint-tablet - 1}) {
        :global(.transparent-toolbar) & {
          box-shadow: 0 0 0 0 ;
        }
      }
    }
  }
}
</style>
